import React from 'react';
import { PinLogo } from '../../Assets/Img/PinLogoBW';
import './Footer.component.scss';

export const FooterComponent:React.FC = ()=>{
  return(
  <div className='footer-container d-flex justify-content-center'>
    <div className='footer-inner'>
      <div className='footer-logo-container'>
        <a href='https://www.pin-ag.de' target='_self'>
        <PinLogo/>
        </a>
      <div className='footer-links'>
        <a href='https://www.pin-ag.de/impressum'>Impressum</a>
        <a href='https://www.pin-ag.de/datenschutz'>Datenschutz</a>
        <a href='https://www.pin-ag.de/impressum'>AGB</a>
      </div>
      <p className='footer-copyright'>&#0169;{` ${new Date().getFullYear()} PIN AG, Alle Rechte Vorbehalten`}</p>
      </div>
    </div>
  </div>
  )
}